import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { PropertyPhotosImageSelector } from '../atomic-components/PropertyPhotosImageSelector';

interface Props {
  disabled: boolean;
}

export const AssetPropertyPhotos: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  return (
    <LaunchpadCard title={t('dashboard.assets.addedit.main.propertyPhotos.title')}>
      <PropertyPhotosImageSelector disabled={disabled} />
    </LaunchpadCard>
  );
};
